var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyPfp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Avatar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_209",
    "data-name": "Ellipse 209",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 59,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-person-outline",
    "data-name": "Icon material-person-outline",
    d: "M18.333,6.9A3.937,3.937,0,1,1,14.4,10.833,3.937,3.937,0,0,1,18.333,6.9m0,16.875c5.569,0,11.438,2.738,11.438,3.938v2.063H6.9V27.708c0-1.2,5.869-3.937,11.438-3.937m0-20.438a7.5,7.5,0,1,0,7.5,7.5,7.5,7.5,0,0,0-7.5-7.5Zm0,16.875c-5.006,0-15,2.513-15,7.5v5.625h30V27.708C33.333,22.721,23.34,20.208,18.333,20.208Z",
    transform: "translate(41.667 41.667)",
    fill: "#727679"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPfp);
export default __webpack_public_path__ + "static/media/empty_pfp.fe6d3cdf3dacf5840df7f7941186d456.svg";
export { ForwardRef as ReactComponent };